// src/slices/contact/reducer.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    contacts: [],
    totalRows: 0,
    currentPage: 1,
    pageSize: 10, // Add default page size
    totalPages: 0, // Add total pages
    contactDetails: null,
    loading: false,
    error: null,
};

const contactSlice = createSlice({
    name: "contact",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setContacts: (state, action) => {
            // Backend response structure: { success, message, data, pagination }
            // Backend returns: { success: true, data: [...], pagination: { currentPage, totalPages, totalContacts, ... } }
            const responseData = action.payload?.data || [];
            state.contacts = Array.isArray(responseData) ? responseData : [];

            // ✅ FIXED: Handle backend pagination structure
            const pagination = action.payload?.pagination;
            state.totalRows =
                action.payload.totalData ||
                action.payload.totalContacts ||
                pagination?.totalContacts ||
                pagination?.totalItems ||
                state.contacts.length || 0;

            if (pagination) {
                state.currentPage = pagination.currentPage || 1;
                state.totalPages = pagination.totalPages || Math.ceil(state.totalRows / state.pageSize);
                if (pagination.itemsPerPage) {
                    state.pageSize = pagination.itemsPerPage;
                }
            } else {
                state.totalPages = Math.ceil(state.totalRows / state.pageSize);
            }
        },
        setContactDetails: (state, action) => {
            state.contactDetails = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearContactDetails: (state) => {
            state.contactDetails = null;
        },
        // ✅ ADD: New action to update pagination
        setPagination: (state, action) => {
            state.currentPage = action.payload.page || state.currentPage;
            state.pageSize = action.payload.pageSize || state.pageSize;
        },
    },
});

export const {
    setLoading,
    setContacts,
    setContactDetails,
    setError,
    clearContactDetails,
    setPagination, // Export the new action
} = contactSlice.actions;

export default contactSlice.reducer;